import { Divider, ListItemIcon, Menu, MenuItem, MenuList } from "@mui/material";
import React from "react";
import { AiOutlinePicture } from "react-icons/ai";
import { GiCash } from "react-icons/gi";
import {
  MdLocalOffer,
  MdOutlineVerifiedUser,
  MdPreview,
  MdRemoveCircleOutline,
} from "react-icons/md";
import { RiVideoFill } from "react-icons/ri";
import { TbEdit } from "react-icons/tb";

const ProductMenu = ({
  context,
  product,
  anchorEl,
  handleClose,
  contextMenu,
  setOpenImageUpdate,
  setOpenVideoUpdate,
  setOpenVariantUpdate,
  setOpenOfferDialog,
  setOpenValidationAllocationDialog,
  setOpenProductUpdate,
  removeProduct,
}) => {
  return (
    <Menu
      {...(context
        ? {
            open: contextMenu !== null,
            anchorReference: "anchorPosition",
            anchorPosition:
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
          }
        : {
            anchorEl: anchorEl,
            open: anchorEl !== null,
          })}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        {/* <MenuItem onClick={() => {}}>
          <ListItemIcon>
            <MdPreview />
          </ListItemIcon>
          View item
        </MenuItem> */}
        <MenuItem onClick={removeProduct}>
          <ListItemIcon>
            <MdRemoveCircleOutline />
          </ListItemIcon>
          Remove item
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenProductUpdate(true);
          }}
        >
          <ListItemIcon>
            <TbEdit />
          </ListItemIcon>
          Edit product
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenImageUpdate(true);
          }}
        >
          <ListItemIcon>
            <AiOutlinePicture />
          </ListItemIcon>
          Manage product images
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenVideoUpdate(true);
          }}
        >
          <ListItemIcon>
            <RiVideoFill />
          </ListItemIcon>
          Manage product videos
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            setOpenVariantUpdate(true);
          }}
        >
          <ListItemIcon>
            <GiCash />
          </ListItemIcon>
          View price variants
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenValidationAllocationDialog(true);
          }}
        >
          <ListItemIcon>
            <MdOutlineVerifiedUser />
          </ListItemIcon>
          Add validation
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            setOpenOfferDialog(true);
          }}
        >
          <ListItemIcon>
            <MdLocalOffer />
          </ListItemIcon>
          Apply offers
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ProductMenu;
